import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const committeeMembersApi = {
    getCommitteeMembers: (committeeId: number): Observable<Dtos.GetCommitteeMembersResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMembers = new Dtos.GetCommitteeMembers();
        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMembersResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMemberById: (id: number): Observable<Dtos.GetCommitteeMemberByIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMemberById = new Dtos.GetCommitteeMemberById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMemberByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getCommitteeMemberByCommitteeId: (committeeId: number): Observable<Dtos.GetCommitteeMemberByCommitteeIdResponse> => {
        //Create the request.
        let request: Dtos.GetCommitteeMemberByCommitteeId = new Dtos.GetCommitteeMemberByCommitteeId();

        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.GetCommitteeMemberByCommitteeIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setCommitteeMember: (committeeMember: Dtos.CommitteeMember): Observable<Dtos.SetCommitteeMemberResponse> => {

        let request: Dtos.SetCommitteeMember = new Dtos.SetCommitteeMember();

        request.committeeMember = committeeMember;

        // send request
        const response: Promise<Dtos.SetCommitteeMemberResponse> = client.post(request);

        return Observable.from(response);
    },
    createCommitteeMember: (committeeId: number): Observable<Dtos.CreateCommitteeMemberResponse> => {
        //Create the request.
        let request: Dtos.CreateCommitteeMember = new Dtos.CreateCommitteeMember();

        request.committeeId = committeeId;

        //Send request.
        const response: Promise<Dtos.CreateCommitteeMemberResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateCommitteeMember: (committeeMember: Dtos.CommitteeMember): Observable<Dtos.ValidateCommitteeMemberResponse> => {

        let request: Dtos.ValidateCommitteeMember = new Dtos.ValidateCommitteeMember();

        request.committeeMember = committeeMember;

        // send request
        const response: Promise<Dtos.ValidateCommitteeMemberResponse> = client.post(request);

        return Observable.from(response);
    },
}